import styled from '@emotion/styled';

export const ImageRoot = styled.img`
	width: ${(props) => props.width};
	height: ${(props) => props.height};
	display: ${({ display }) => display};
`;

export const FailedImageContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: ${(props) => props.width};
	height: ${(props) => props.height};

	> .icon {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
		background-color: var(--black-10);
		border-radius: var(--small-border-radius);
	}
`;
